import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  model,
} from '@angular/core';
import { DataGridComponent } from './data-grid.component';

/** One tab of the pane's strip; the pane switches its own content on `activeTab`. */
export interface GridDetailTab {
  id: string;
  labelKey: string;
}

/**
 * The frame of a master-detail grid's row-detail pane (WAP-1733): the overlay
 * over the Data View (absolute, inset 0 inside `app-grid-data-view`, whose
 * forced-open state follows this element's presence), the close icon, the
 * `paneHeader` slot and the tab strip; the pane's content is the default slot
 * and stays per explorer. Close reaches the grid through DI
 * (`clearSelectedRow()`, which empties the host's `selectedItem` through
 * `selectedRowDataChange`), so the element must sit inside `<app-data-grid>`.
 * The header vocabulary (`grid-detail-pane__info` / `__time` / `__title` /
 * `__link`) styles the projected header. Declared in DataGridModule.
 */
@Component({
  selector: 'app-grid-detail-pane',
  templateUrl: './grid-detail-pane.component.html',
  styleUrls: ['./grid-detail-pane.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  host: { class: 'grid-detail-pane' },
})
export class GridDetailPaneComponent {
  private readonly grid = inject(DataGridComponent);

  readonly tabs = input<GridDetailTab[]>([]);
  readonly activeTab = model<string>('');

  close(): void {
    this.grid.clearSelectedRow();
  }
}
